import NewOnProduct from './new_on_product.vue';

export default NewOnProduct;
